import { getCheckboxSx } from '../../../EditTree/style'

export const messageWrapperSx = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'start',
}

export const titleWrapperSx = {
  flexDirection: 'row',
  width: '100%',
  alignItems: 'start',
  paddingBottom: '10px',
  gap: '4px',
}

export const checkboxLabelSx = {
  fontWeight: 300,
  fontSize: '15px',
  lineHeight: '18px',
  paddingTop: 0,
}

export const checkboxInfoWrapperSx = {
  backgroundColor: 'white',
  padding: '4px 8px 4px 32px',
  borderRadius: '8px',
  flexDirection: 'row',
  alignItems: 'center',
  width: 'max-content',
  gap: '8px',
}

export const messageSx = {
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '16.41px',
  color: '#5F5F5F',
}

export const titleSx = {
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '16.8px',
}

export const notificationWrapperSx = {
  backgroundColor: '#F6F6F6',
  padding: '8px 16px 16px 16px',
  borderRadius: '4px',
  border: '1px solid #EBE8E8',
  boxShadow: '0px 1px 2px 0px #00000040',
}

export const checkedSx = {
  padding: '0',
  cursor: 'default',
  width: '16px',
  height: '16px',
  color: 'rgba(3, 72, 126, 1)!important',
}

export const notCheckedSx = {
  padding: '0',
  cursor: 'default',
  width: '16px',
  height: '16px',
}

export const indeterminateSx = {
  ...getCheckboxSx(true, false, false),
  padding: '0',
  width: '16px',
  cursor: 'default',
}

export const dividerSx = { backfroundColor: '#E0DFDF', marginBottom: '10px' }
